import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { designHuddleService } from 'services';

export const useCreateProject = (
  clinid: string | undefined,
  sku: string,
  setShowCustomizationModal: Dispatch<SetStateAction<boolean>>,
  setActiveProjectId: Dispatch<SetStateAction<string>>
) => {
  const queryClient = useQueryClient();
  return useMutation(
    () => {
      return designHuddleService.createProject(clinid, sku);
    },
    {
      onSuccess: (data, variables, context) => {
        setActiveProjectId(data);
        setShowCustomizationModal(true);
        queryClient.invalidateQueries({
          queryKey: [ServerStateKeysEnum.marketingProjects],
        });
      },
      onError: () => {},
    }
  );
};
